import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FileService } from '@schoolbelle/api/file';
import { GroupService } from '@schoolbelle/api/group';

import { REST_SERVER_HOST } from '@schoolbelle/api/tokens';
import { map, switchMap } from 'rxjs/operators';
import { mapValues, pickBy, identity } from 'lodash-es';

export type FaceReference = {
  reference_id:string,
  group_id:any,
  scope:string,
  img:string,
  name:string,
  descriptor:Float32Array
}
export type FaceRecognition = {
  recognition_id:string
  distnace:number
  reference_id:string
  face_id:string
  scope:string
}
export type FaceDetection = {
  face_id:string
  box: {left:string, top:string, width:string, height:string},
  file_id:string
  matches: FaceRecognition[]
  score:number  
  descriptor:string|Float32Array
}


@Injectable({
  providedIn: 'root'
})
export class FaceService {

  constructor(
    private http: HttpClient,
    private group: GroupService,
    private flie: FileService,
    @Inject(REST_SERVER_HOST) private serverHost: string

  ) { }



  listReferences (params?:{scope?:string}) {
    const url = `${this.serverHost}/group/face/reference/list`;
    let httpParams = new HttpParams({
      fromObject: mapValues(pickBy(params, identity), v => '' + v)
    });

    return this.group.getAccessToken().pipe(
      switchMap(access_token=>{
        return this.http
          .get<(FaceReference&{descriptor:string})[]>(url, {
            params: httpParams,
            headers: { Authorization: 'Bearer ' + access_token },
          })
      }),
    )   

  }

  deleteReference (params:{reference_id:string}) {
    const url = `${this.serverHost}/group/face/reference/delete`;
    return this.group.getAccessToken().pipe(
      switchMap(access_token=>{
        return this.http
          .post(url, params, {
            headers: { Authorization: 'Bearer ' + access_token },
          })
      }),
    )   

  }
  listDetections (params:{file_id:any}) {
    const url = `${this.serverHost}/group/face/detected/list`;
    let httpParams = new HttpParams({
      fromObject: mapValues(pickBy(params, identity), v => '' + v)
    });


    return this.group.getAccessToken().pipe(
      switchMap(access_token=>{
        return this.http
          .get<FaceDetection[]>(url, {
            params:httpParams,
            headers: { Authorization: 'Bearer ' + access_token },
          })
      }),
      // temp fix
      map(list=>list.map(li=>({
        ...li, 
        box: typeof li.box === 'string' ? JSON.parse(li.box as any) : li.box,
      }))),
      // temp fix
      )   

  }
  insertRecognition (params:{file_id:string, face_id:string, scope:string}) {
    const url = `${this.serverHost}/group/face/recognition/insert`;
    return this.group.getAccessToken().pipe(
      switchMap((access_token)=>{
        return this.http.post(url, {...params, distance:0}, {
          headers: { Authorization: 'Bearer ' + access_token },
          responseType:'text',
        })
      }),
    )
  }
  nullifyRecognition (params:{recognition_id:string}) {
    const url = `${this.serverHost}/group/face/recognition/nullify`;
    return this.group.getAccessToken().pipe(
      switchMap((access_token)=>{
        return this.http.post(url, params, {
          headers: { Authorization: 'Bearer ' + access_token },
          responseType:'text',
        })
      }),
    )

  }
}
